import { render, staticRenderFns } from "./KnowledgeBaseSettings.vue?vue&type=template&id=0dc3f2f8"
import script from "./KnowledgeBaseSettings.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports